import React from "react";
import {
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";
import type { Package } from "../types/proposal.types";

interface AlternatePackagesSectionProps {
  packages: Package[];
  selected: Package[];
  onChange: (pkgs: Package[]) => void;
}

const AlternatePackagesSection: React.FC<AlternatePackagesSectionProps> = ({
  packages,
  selected,
  onChange,
}) => {
  const handleToggle = (pkg: Package) => {
    const exists = selected.some((p) => p.id === pkg.id);
    const updated = exists
      ? selected.filter((p) => p.id !== pkg.id)
      : [...selected, pkg];
    onChange(updated);
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        Alternate Packages
      </Typography>
      {packages.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No other packages available for this booking type.
        </Typography>
      ) : (
        <FormGroup>
          {packages.map((pkg) => (
            <FormControlLabel
              key={pkg.id}
              control={
                <Checkbox
                  checked={selected.some((p) => p.id === pkg.id)}
                  onChange={() => handleToggle(pkg)}
                />
              }
              label={`${pkg.name} — $${pkg.price.toLocaleString()}`}
            />
          ))}
        </FormGroup>
      )}
    </Box>
  );
};

export default AlternatePackagesSection;
